import List from 'list.js';

class AccordeonSearch {
  constructor(element) {
    this.accordeon = $(element) || $('.accordeon-wrap');
    this.search = $('.form-control', this.accordeon);
    this.info = $('.alert', this.accordeon);
  }
  
  init() {
    this.setList();
    this.updateHandler();
  }

  /**
   * Initiate the List library
   */
  setList() {
    this.list = new List(this.accordeon[0], {
      valueNames: ['card-title'],
    });

    const listCreatedEvent = new CustomEvent('listjs.created', {
      detail: this.list,
    });

    this.accordeon[0].dispatchEvent(listCreatedEvent);
  }

  /**
   * Run functions when the List object gets updated
   */
  updateHandler() {
    this.list.on('updated', () => {
      this.showInfo();
    });
  }

  /**
   * Show an info box when there are no results
   */
  showInfo() {
    if (this.info.length) {
      this.info.toggle(this.list.matchingItems.length === 0);
    }
  }
}

$(document).ready(() => {
  $('.accordeon-wrap').each((index, el) => {
    new AccordeonSearch(el).init();
  });
});
